<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodawanie nowego błędu
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="error.name"
                                :error-messages="ErrorNameErrors"
                                label="Nazwa błędu"
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    :loading="actionLoading"
                    @click="addError()"
                >
                    Dodaj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'AddErrorDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            error: {
                name: null,
            },
            actionLoading: false,
        }
    },
    validations: {
        error: {
            name: {
                required
            },
        }
    },
    computed: {
        ErrorNameErrors() {
            const errors = []

            if (!this.$v.error.name.$dirty) return errors
            !this.$v.error.name.required && errors.push('Proszę podać nazwę błędu.')

            return errors
        },
    },
    methods: {
        addError() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true

            this.$store.dispatch('complaints/createError', this.error)
                .then(() => {
                    this.actionLoading = false
                    this.onClose()
                })
                .catch(error => {
                    this.actionLoading = false
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            setTimeout(() => {
                this.error.name = null
            }, 500)
            this.$v.$reset()
            this.$emit('on-close')
        },
    }
}
</script>

